import { render, staticRenderFns } from "./shop-selection-modal.vue?vue&type=template&id=992b56c0&scoped=true&"
import script from "./shop-selection-modal.vue?vue&type=script&lang=js&"
export * from "./shop-selection-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "992b56c0",
  null
  
)

export default component.exports